<template>
  <section>
    <header-com />

    <div class="code" v-copy='{callback,textCopy:code}'>
      <div class="title">顺丰快递</div>
      <div class="number">{{code}}</div>
    </div>

    <div class="expressList" v-for="(item,index) of expressList" :key="index">
      <div class="box">
        <img v-if="index==0" class="light_dian" src="/images/order/express_light.png" />
        <img v-if="index!=0" class="gray_dian" src="/images/order/express_dian.png" />
        <div>{{item.acceptAddress}} {{item.acceptDate}} {{item.acceptTime}}</div>
        <div class="remark">{{item.remark}}</div>
      </div>
    </div>

  </section>
</template>

<script>
import orderApi from "@/axios/order";
export default {
  name: "index",
  computed: {
    customerId() {
      return this.$store.state.customerId;
    },
  },
  data() {
    return {
      id: this.$route.query.id,
      code: this.$route.query.code,
      expressList: [],
      bb:'ccxx'
    };
  },
  created() {
    this.getDetail();
  },
  mounted() {},
  methods: {
    callback() {

    },
    
    getDetail() {
      orderApi.expressDetail(this.id, { uid: this.customerId }).then((res) => {
        console.log("aa", res);
        this.expressList = res;
      });
    },
  },
};
</script>

<style scoped lang="scss">
section {
  width: 100%;
  height: 100%;
  padding-top: 100px;
}
.code {
  width: 690px;
  margin: 0 auto;
  background: #f7f7f7;
  border-radius: 12px;
  padding: 20px;
  box-sizing: border-box;
  margin-bottom: 32px;
  .title {
    font-size: 24px;
    color: #cacaca;
  }
  .number {
    width: 100%;
    line-height: 56px;
    font-size: 40px;
    margin-top: 8px;
    font-weight: 500;
    background: url("/images/order/copy_icon.png") no-repeat right;
    background-size: 36px 36px;
  }
}
.expressList {
  width: 100%;
  box-sizing: border-box;
  padding-left: 24px;
  padding-right: 30px;
  display: flex;
  flex-direction: row-reverse;
  .box {
    width: 674px;
    padding-bottom: 40px;
    padding-left: 28px;
    box-sizing: border-box;
    color: #737373;
    font-size: 24px;
    line-height: 34px;
    border-left: 4px solid #dedede;
    position: relative;
    .gray_dian {
      width: 16px;
      height: 16px;
      position: absolute;
      top: -2px;
      left: -10px;
    }
    .light_dian{
      width: 28px;
      height: 28px;
      position: absolute;
      top: -6px;
      left: -16px;
    }
    .remark{
      font-size:24px;
      color:#333;
      font-weight: 500;
    }
  }
  &:nth-last-child(1) > .box {
    border-left-color: transparent;
  }
}
</style>
